import { render, staticRenderFns } from "./SiportWidget.vue?vue&type=template&id=58e143ef&scoped=true&"
import script from "./SiportWidget.vue?vue&type=script&lang=js&"
export * from "./SiportWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e143ef",
  null
  
)

export default component.exports